import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommunicationService } from '../../data/services/view/communication.service';

@Component({
  selector: 'app-tracking-timeline',
  templateUrl: './tracking-timeline.component.html',
  styleUrls: ['./tracking-timeline.component.scss']
})
export class TrackingTimelineComponent implements OnInit, OnDestroy {

  constructor(public communicationService: CommunicationService) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {}

  get visible(): boolean {
    return this.communicationService.showTracking;
  }

  set visible(value: boolean) {
    this.communicationService.showTracking = value;
  }

  get events() {
    return this.communicationService.trackingEvents;
  }

  get email() {
    return this.communicationService.selectedEmail;
  }

  /**
   * Cierra el dialog de tracking
   */
  close() {
    this.visible = false;
  }

  /**
   * Calcula el tiempo transcurrido desde un evento
   * @param timestamp - Fecha del evento
   * @returns String formateado (ej: "hace 2 días")
   */
  getTimeDiff(timestamp: string | Date): string {
    const now = new Date();
    const date = new Date(timestamp);
    const diff = now.getTime() - date.getTime();

    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(diff / 3600000);
    const days = Math.floor(diff / 86400000);

    if (days > 0) return `hace ${days} día${days > 1 ? 's' : ''}`;
    if (hours > 0) return `hace ${hours} hora${hours > 1 ? 's' : ''}`;
    if (minutes > 0) return `hace ${minutes} minuto${minutes > 1 ? 's' : ''}`;

    return 'hace un momento';
  }

  /**
   * Formatea una fecha a formato legible
   * @param timestamp - Fecha a formatear
   * @returns String formateado
   */
  formatDate(timestamp: string | Date): string {
    return new Date(timestamp).toLocaleString('es-MX', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  }
}
